import DashboardServiceItem from '@/modules/myServices/entities/DashboardServiceItem'
import { ChipsColorI } from '@/typescript/types/ui-components/BaseChipsI'
import { DashboardCertificateStatusI, DashboardSslServiceI } from '@/modules/myServices/types/api/DashboardServices'

export const CERTIFICATE_STATUS_LABELS: Record<DashboardCertificateStatusI, string> = {
  awaiting_configuration: 'Awaiting Configuration',
  configuration_submitted: 'Configuration Submitted',
  processing: 'Processing',
  reissue: 'Reissue',
  unpaid_invoice: 'You have unpaid invoice',
  active: 'Active',
  completed: 'Completed',
  expired: 'Expired',
  terminated: 'Terminated',
  cancelled: 'Cancelled',
  unknown: 'Unknown',
}

const CERTIFICATE_STATUS_TONES: Record<DashboardCertificateStatusI, ChipsColorI> = {
  awaiting_configuration: 'outline_turquoise',
  configuration_submitted: 'orange',
  processing: 'orange',
  reissue: 'orange',
  unpaid_invoice: 'orange',
  active: 'green',
  completed: 'blue',
  expired: 'pink',
  terminated: 'red',
  cancelled: 'dark_blue',
  unknown: 'gray',
}

export default class DashboardSslItem extends DashboardServiceItem {
  /** The domain the certificate covers. */
  commonName: string
  certificateStatus: DashboardCertificateStatusI

  constructor(service: DashboardSslServiceI, currency: string) {
    super(service, currency)

    this.commonName = service.attributes?.commonName || 'You don’t have a domain'
    this.certificateStatus = service.attributes?.certificateStatus ?? 'unknown'
  }

  get certificateStatusLabel(): string {
    return CERTIFICATE_STATUS_LABELS[this.certificateStatus] ?? CERTIFICATE_STATUS_LABELS.unknown
  }

  get certificateStatusTone(): ChipsColorI {
    return CERTIFICATE_STATUS_TONES[this.certificateStatus] ?? CERTIFICATE_STATUS_TONES.unknown
  }

  /** A certificate is valid for a year, so a one-time charge reads as the yearly price. */
  get priceLabel(): string {
    if (this.billingCycle === 'one_time') return `${this.currency} ${this.amount} / year`
    return super.priceLabel
  }

  get needsConfiguration(): boolean {
    return this.certificateStatus === 'awaiting_configuration'
  }

  get isManageDisabled(): boolean {
    return this.certificateStatus === 'terminated' || this.certificateStatus === 'cancelled'
  }
}
